import React from "react";
import { useI18n } from "../i18n/I18nContext";

const WhyItMatters = () => {
  const { t } = useI18n();
  return (
    <section className="bg-white" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 section">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="accent-bar" />
            <p className="eyebrow mb-3">{t.why.eyebrow}</p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              {t.why.title}
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed max-w-md">{t.why.lead}</p>
            <p className="mt-8 text-sm text-slate-500 italic border-l-2 border-[#016C36] pl-4 max-w-md">{t.why.note}</p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-4">
              {t.why.points.map((p, i) => (
                <div key={i} className="card p-6" data-testid={`why-point-${i}`}>
                  <p className="font-mono-tech text-[11px] text-slate-400">{String(i + 1).padStart(2, "0")}</p>
                  <h3 className="font-display font-semibold text-base mt-2">{p.t}</h3>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed">{p.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyItMatters;
